// extracted by mini-css-extract-plugin
module.exports = {"navigation":"mobile_navigation__qt_9D","screen":"mobile_screen__e4fSo"};